var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0556 2.88358C11.1296 1.80964 12.8708 1.80964 13.9447 2.88358L21.1163 10.0552C22.1902 11.1291 22.1902 12.8703 21.1163 13.9442L13.9447 21.1158C12.8708 22.1898 11.1296 22.1898 10.0556 21.1158L2.88407 13.9442C1.81013 12.8703 1.81013 11.1291 2.88407 10.0552L10.0556 2.88358ZM11.25 15.9998C11.25 16.414 11.5858 16.7498 12 16.7498C12.4142 16.7498 12.75 16.414 12.75 15.9998V15.4998C12.75 15.0855 12.4142 14.7498 12 14.7498C11.5858 14.7498 11.25 15.0863 11.25 15.5005V15.9998ZM11.25 11.9998C11.25 12.414 11.5858 12.7498 12 12.7498C12.4142 12.7498 12.75 12.414 12.75 11.9998V7.99976C12.75 7.58554 12.4142 7.24976 12 7.24976C11.5858 7.24976 11.25 7.58554 11.25 7.99976V11.9998Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFilled);
export default __webpack_public_path__ + "static/media/errorFilled.f1f3305cb2711d7a6f1abb4c6330af5f.svg";
export { ForwardRef as ReactComponent };